// extracted by mini-css-extract-plugin
export default {"chevronLeft":"B38BaY"};